import AddLocationDialog from './AddLocationDialog';

export default AddLocationDialog;
